import { Spinner } from 'reactstrap';
import EventRangePickers from './eventRangePickers';
import useChangeEventDuration from './useChangeEventDuration';
import './styles.scss';

export type ChangeEventDurationProps = {
  onCancel: () => void;
  timezone?: any;
  timezoneOffset: number;
  ecgDataMap: any;
  studyId: string;
  profileId: string;
  selectedEvent: any;
};

/**
 * Renders the Change event duration modal for a selected ECG event, exposing start and end date and time pickers. Pulls state and handlers from useChangeEventDuration and swaps the Done button label for a spinner while the update is saving.
 *
 * @param props - Modal configuration and callbacks forwarded straight to useChangeEventDuration.
 * @returns The change-duration modal body with its range pickers and Cancel/Done footer.
 */
const ChangeEventDuration = ({
  onCancel,
  timezone,
  timezoneOffset,
  ecgDataMap,
  studyId,
  profileId,
  selectedEvent,
}: ChangeEventDurationProps) => {
  const { state, onChange, onClickCancel, onClickSave } = useChangeEventDuration({
    onCancel,
    timezone,
    timezoneOffset,
    ecgDataMap,
    studyId,
    profileId,
    selectedEvent,
  });

  return (
    <>
      <div className="draggable-modal-content">
        <div className="content-title">Change event duration</div>
        <div className="content">
          <EventRangePickers
            startDate={state.startDate}
            endDate={state.endDate}
            startTime={state.startTime}
            endTime={state.endTime}
            onChangePicker={onChange}
            error={state.errorObject}
          />
        </div>
      </div>
      <div className="footer-btn">
        <button
          id="rhythm-event-cancel-change-duration"
          className="draggable-modal-btn"
          onClick={onClickCancel}
        >
          Cancel
        </button>
        <button
          id="rhythm-event-change-duration"
          className="draggable-modal-btn btn-main"
          onClick={onClickSave}
        >
          {state.isSaving ? (
            // eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined
            <Spinner>{''}</Spinner>
          ) : (
            'Done'
          )}
        </button>
      </div>
    </>
  );
};

export default ChangeEventDuration;
